module.exports = __webpack_public_path__ + "media/images/logos/removebg-afb909ce04006745aa936b2f24cfa533.svg";